<template>
  <Container class="flex-col align-start">
    <h2 style="padding:5px 0;margin:10px 20px;border-bottom:3px solid var(--border);">客户交易风险评估及分类处置管理</h2>
    <div class="flex-wrap" style="margin:0 20px 10px;gap:10px;align-items:center;">
      <Input search clearable placeholder="客户名称 / 统一社会信用代码" style="width:240px;" />
      <Select placeholder="风险等级" transfer style="width:140px;" clearable />
      <Select placeholder="处置分类" transfer style="width:140px;" clearable />
      <DatePicker type="daterange" placeholder="评估日期" transfer style="width:240px;" />
      <Button type="primary" icon="ios-search">查询</Button>
      <Button icon="md-download">导出</Button>
    </div>
    <div style="padding:0 20px;height:calc(100% - 120px);width:100%;position:relative;">
      <BaseTable ref="table" :columns="cols" :data="items" full />
    </div>
  </Container>
</template>

<script>
import Container from '@/components/app/container';

export default {
  routerOption: {},
  components: { Container },
  data() {
    return {
      items: [],
      cols: [
        { title: '序号', width: 60, type: 'index' },
        { title: '客户', minWidth: 160, key: 'customer' },
        { title: '风险等级', width: 100, key: 'risk_level' },
        { title: '评估结论', minWidth: 180, key: 'conclusion' },
        { title: '处置分类', width: 120, key: 'disposal' },
        { title: '主要风险点', minWidth: 200, key: 'risk_points' },
        { title: '评估日期', width: 120, key: 'eval_date' },
        { title: '责任人', width: 100, key: 'owner', type: 'user' },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.table && this.$refs.table.calcTableHeight) {
        setTimeout(() => this.$refs.table.calcTableHeight(), 300);
      }
    });
  },
};
</script>

<style lang="less" scoped>
</style>
